import {
  SystemNamesEnum,
  WorkflowExternalStepDefDtoModel,
  WorkflowUiDefinitionModel
} from "@well/iriro-frontend-libs/workflows/domain";
import {DefinitionsNameEnum} from "./DefinitionsName.enum";

class PaymentDoneDefinition implements WorkflowUiDefinitionModel {
  configuredBy= null;
  configuredForOwner= false;
  defaultLabel= null
  name= DefinitionsNameEnum.PAYMENT_DONE
  systemName= SystemNamesEnum.DELIVERY
  definitionFile= 'payment_done_definition'
  uiSteps = {
    displayFinalPaymentDueDate: WorkflowExternalStepDefDtoModel.createWorkflowStepVoModel("FINAL_DUE_DATE" , SystemNamesEnum.ANGULAR_FRONTEND),
  }
  uuid= null
  valid= null
  validFrom= null
  validTo= null
}

export const paymentDoneDefinition = new PaymentDoneDefinition();

